<template>
  <v-app>
    <TopNav v-if="hide" />
    <v-main>
      <router-view></router-view>
    </v-main>
    <Footer v-if="hide" />
  </v-app>
</template>

<script>
import TopNav from "./components/TopNav";
import Footer from "./components/Footer";

export default {
  name: "App",
  data() {
    return {
      isIdle: false
    }
  },
  components: {
    TopNav,
    Footer,
  },
  computed: {
    hide() {
      return this.$route.path !== "/login";
    },
  },
   onIdle() {
    this.isIdle = true
  },
  onActive() {
    if(this.isIdle)
    location.reload();
  }
};
</script>

